(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[312],{

/***/ 190:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in",
      function () {
        return __webpack_require__(5043);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HI": function() { return /* reexport */ QASignInPage; },
  "FW": function() { return /* reexport */ SignInPage; },
  "C0": function() { return /* reexport */ SignOutPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./common/i18n/index.ts + 17 modules
var i18n = __webpack_require__(2948);
// EXTERNAL MODULE: ./common/uaa/utils/auth-handler.ts + 1 modules
var auth_handler = __webpack_require__(5295);
// EXTERNAL MODULE: ./common/ui-components/index.ts + 730 modules
var ui_components = __webpack_require__(8389);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./modules/uaa/intl/index.ts + 4 modules
var intl = __webpack_require__(3546);
;// CONCATENATED MODULE: ./modules/uaa/containers/qa/sign-in.tsx
/* provided dependency */ var process = __webpack_require__(4155);












function QASignIn() {
    var handleInputChange = function handleInputChange(event) {
        var _target = event.target, name = _target.name, value = _target.value;
        setCredentials(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, name, value));
        });
    };
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var ref = (0,react.useState)({
        email: "",
        password: ""
    }), credentials = ref[0], setCredentials = ref[1];
    var router = (0,next_router.useRouter)();
    function handleSubmit(event) {
        return _handleSubmit.apply(this, arguments);
    }
    function _handleSubmit() {
        _handleSubmit = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                event.preventDefault();
                if (credentials.email === process.env.NEXT_PUBLIC_AUTOMATION_USER_EMAIL && credentials.password === process.env.NEXT_PUBLIC_AUTOMATION_USER_PASSWORD) {
                    auth_handler/* AuthHandler.setTokens */.s.setTokens(process.env.NEXT_PUBLIC_AUTOMATION_USER_TOKEN || "", "no-refresh-token");
                    router.push("/");
                    return [
                        2,
                        null
                    ];
                }
                return [
                    2
                ];
            });
        });
        return _handleSubmit.apply(this, arguments);
    }
    if (true) {
        router.replace("/404");
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        direction: "column",
        align: "center",
        justify: "center",
        w: "100vw",
        h: "100vh",
        bg: "gray.100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                direction: "column",
                align: "center",
                justify: "center",
                gap: 6,
                bg: "white",
                borderRadius: 8,
                zIndex: 1,
                padding: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Raio */.Zo, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        fontSize: "lg",
                        fontWeight: "700",
                        lineHeight: 7,
                        children: formatMessage({
                            id: intl/* uaaIntlIds.signIn.welcomeMessage */.SR.signIn.welcomeMessage
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        children: formatMessage({
                            id: intl/* uaaIntlIds.signIn.signInInstruction */.SR.signIn.signInInstruction
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Input */.II, {
                        type: "email",
                        name: "email",
                        placeholder: formatMessage({
                            id: intl/* uaaIntlIds.signIn.qa.inputs.email.placeholder */.SR.signIn.qa.inputs.email.placeholder
                        }),
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Input */.II, {
                        type: "password",
                        name: "password",
                        placeholder: formatMessage({
                            id: intl/* uaaIntlIds.signIn.qa.inputs.password.placeholder */.SR.signIn.qa.inputs.password.placeholder
                        }),
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                        onClick: handleSubmit,
                        children: formatMessage({
                            id: intl/* uaaIntlIds.signIn.button.label */.SR.signIn.button.label
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Box */.xu, {
                position: "fixed",
                bottom: 12,
                right: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Image */.Ee, {
                    src: "/images/man-riding-bike.svg",
                    alt: formatMessage({
                        id: intl/* uaaIntlIds.signIn.manRidingBikeAlt */.SR.signIn.manRidingBikeAlt
                    }),
                    boxSize: {
                        base: "240px",
                        lg: "240px",
                        sm: "180px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Box */.xu, {
                position: "fixed",
                w: "calc(100vw - 32px)",
                bottom: 8,
                right: 0,
                borderTop: "4px",
                borderLeftRadius: 8,
                color: "#1759FF"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./modules/uaa/containers/qa/index.ts


// EXTERNAL MODULE: ./common/uaa/index.ts + 9 modules
var uaa = __webpack_require__(643);
;// CONCATENATED MODULE: ./modules/uaa/containers/sign-in/sign-in.tsx






function SignIn() {
    var formatMessage = (0,i18n/* useIntl */.YB)().formatMessage;
    var router = (0,next_router.useRouter)();
    var signIn = (0,uaa/* useLogin */.f0)({
        onSuccess: function() {
            router === null || router === void 0 ? void 0 : router.push("/");
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
        direction: "column",
        align: "center",
        justify: "center",
        w: "100vw",
        h: "100vh",
        bg: "gray.100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_components/* Flex */.kC, {
                direction: "column",
                align: "center",
                justify: "center",
                w: "24rem",
                h: "16.5rem",
                gap: 6,
                bg: "white",
                borderRadius: 8,
                zIndex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Raio */.Zo, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        fontSize: "lg",
                        fontWeight: "700",
                        lineHeight: 7,
                        children: formatMessage({
                            id: intl/* uaaIntlIds.signIn.welcomeMessage */.SR.signIn.welcomeMessage
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Text */.xv, {
                        children: formatMessage({
                            id: intl/* uaaIntlIds.signIn.signInInstruction */.SR.signIn.signInInstruction
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Button */.zx, {
                        onClick: function() {
                            return signIn();
                        },
                        children: formatMessage({
                            id: intl/* uaaIntlIds.signIn.button.label */.SR.signIn.button.label
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Box */.xu, {
                position: "fixed",
                bottom: 12,
                right: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Image */.Ee, {
                    src: "/images/man-riding-bike.svg",
                    alt: formatMessage({
                        id: intl/* uaaIntlIds.signIn.manRidingBikeAlt */.SR.signIn.manRidingBikeAlt
                    }),
                    boxSize: {
                        base: "240px",
                        lg: "240px",
                        sm: "180px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_components/* Box */.xu, {
                position: "fixed",
                w: "calc(100vw - 32px)",
                bottom: 8,
                right: 0,
                borderTop: "4px",
                borderLeftRadius: 8,
                color: "#1759FF"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./modules/uaa/containers/sign-in/index.ts


;// CONCATENATED MODULE: ./modules/uaa/containers/sign-out/sign-out.tsx


function SignOut() {
    var router = (0,next_router.useRouter)();
    (0,uaa/* useLogout */.aU)({
        onSuccess: function() {
            router === null || router === void 0 ? void 0 : router.replace("/sign-in");
        }
    });
    return null;
}

;// CONCATENATED MODULE: ./modules/uaa/containers/sign-out/index.ts


;// CONCATENATED MODULE: ./modules/uaa/containers/index.ts




;// CONCATENATED MODULE: ./modules/uaa/pages/qa/sign-in.page.tsx



function QASignInPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "icon",
                    href: "/favicon.ico"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QASignIn, {})
        ]
    });
}

;// CONCATENATED MODULE: ./modules/uaa/pages/sign-in.page.tsx



function SignInPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Sign in"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Generated by create next app"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn, {})
        ]
    });
}

;// CONCATENATED MODULE: ./modules/uaa/pages/sign-out.page.tsx



function SignOutPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Sign out"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Generated by create next app"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignOut, {})
        ]
    });
}

;// CONCATENATED MODULE: ./modules/uaa/pages/index.ts




;// CONCATENATED MODULE: ./modules/uaa/index.ts



/***/ }),

/***/ 5043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _modules_uaa__WEBPACK_IMPORTED_MODULE_0__.FW; }
/* harmony export */ });
/* harmony import */ var _modules_uaa__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7474);



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(190); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);